// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73931b39","453":"b94d6ebd","732":"a800d94f"}[chunkId] + ".chunk.js";
};